// extracted by mini-css-extract-plugin
export default {"root":"style_root__pU4Ts","container":"style_container__zYV8l","input":"style_input__t96c3","switch":"style_switch__ImBZp"};